import { z } from 'zod';
import type { Product, ProductLine } from './product.js';

/** Recursieve boom: product → regels → (optioneel) sub-product-boom. (Alleen types; geen zod-schema i.v.m. transform-types.) */
export interface TreeNode {
  product: Product;
  lines: TreeLine[];
  /** true als dit product al eerder in het pad voorkwam (cyclus) — kinderen zijn dan niet geladen */
  cycle?: boolean;
  /** true als de maximale diepte bereikt is en kinderen niet geladen zijn */
  truncated?: boolean;
}

export interface TreeLine {
  line: ProductLine;
  child?: TreeNode | null;
}

export const TreeQuerySchema = z.object({
  depth: z.coerce.number().int().min(1).max(20).default(10),
});
export type TreeQuery = z.infer<typeof TreeQuerySchema>;
